import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { PageKit } from "components/common/PageContainer/PageKit";
import { Store } from "state/store";
import { Col } from "reactstrap";
import { defaultLoanDetails, LoanDetails } from "domain/yourBBLS";
import { YourBounceBackLoan } from "components/YourBBLS/YourBounceBackLoan";
import { Menu } from "domain/menuOptions";
import { YOUR_BBLS_SCREEN_TITLE } from "./Title.const";
import { ONE, THREE } from "domain/aboutYourLoan";

export type YourBBLSScreenProps = {
  store: Store;
};

const YourBBLSScreen = ({ store }: YourBBLSScreenProps) => {
  document.title = YOUR_BBLS_SCREEN_TITLE;
  const [loanDetails, setLoanDetails] =
    useState<LoanDetails>(defaultLoanDetails());
  const {
    aboutYourLoanStore,
    indicativeRepaymentOptionsStore,
    selectedTreatmentStore,
    menuStore,
    fetching,
    error,
  } = store;
  const aboutYourLoan = aboutYourLoanStore.data;
  useEffect(() => {
    const RHTaken =
      aboutYourLoan.CIRHTaken === ONE && aboutYourLoan.CRHTaken === THREE;
    const isTreatmentTaken = RHTaken || aboutYourLoan.fullTermExtensionTaken;
    if (isTreatmentTaken) {
      RHTaken
        ? menuStore.setMenu(Menu.RequestRepaymentHoliday)
        : menuStore.setMenu(Menu.ExtendTerm);
    } else menuStore.setDefaultMenu();
    const calculateRepaymentOnMount = async () => {
      const calculateRepaymentOption =
        await indicativeRepaymentOptionsStore.postIndicativeRepaymentOptions(
          aboutYourLoan
        );
      calculateRepaymentOption &&
        setLoanDetails({
          ...aboutYourLoan,
          ...calculateRepaymentOption.existingLoanDetails,
        });
    };
    calculateRepaymentOnMount();
    selectedTreatmentStore.reset();
  }, [
    indicativeRepaymentOptionsStore,
    aboutYourLoan,
    menuStore,
    selectedTreatmentStore,
  ]);

  return (
    <>
      <PageKit selectedMenu={Menu.YourBounceBackLoan} menus={menuStore.data} />
      <Col className="content-body">
        <YourBounceBackLoan
          fetching={fetching}
          error={error}
          loanDetails={loanDetails}
        />
      </Col>
    </>
  );
};

const YourBBLSScreenObserver = observer(YourBBLSScreen);
export { YourBBLSScreenObserver as YourBBLSScreen };
